import React from "react";
import Hero from "../components/Hero";
import { PageCTA } from "../components/PageHeader";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <PageCTA
        title="Masz pytania? Umów bezpłatną rozmowę."
        text="Krótka, niezobowiązująca rozmowa — zobaczymy razem, gdzie jest problem i jak go rozwiązać."
        buttonLabel="Napisz do mnie"
        to="/kontakt"
        secondary={{ to: "/oferta", label: "Zobacz ofertę" }}
      />
    </div>
  );
}
